module.exports = new __parcel__URL__("GoldMiniPartnerBadge.static.5f3b45ae.svg").toString();